<template>
    <div class="column is-12">
        <label class="label is-size-7 is-uppercase has-text-grey-light mb-2">
            {{ translate("admin_schedules_list.delete.scope_label") }}
        </label>
        <div class="buttons">
            <button
                v-for="option in modeOptions"
                :key="option.value"
                class="button"
                :class="{ 'is-primary': store.mode === option.value }"
                @click="store.setMode(option.value)"
            >
                {{ option.label }}
            </button>
        </div>

        <div class="columns" v-if="store.mode === DeleteFightsMode.Schedule || store.mode === DeleteFightsMode.Mat">
            <div class="column">
                <label class="label is-size-7 is-uppercase has-text-grey-light">
                    {{ translate("admin_schedules_list.delete.schedule_label") }}
                </label>
                <div class="control">
                    <div class="select is-fullwidth">
                        <select v-model.number="selectedScheduleId">
                            <option v-for="schedule in store.schedules" :key="schedule.id" :value="schedule.id">
                                {{ schedule.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="column" v-if="store.mode === DeleteFightsMode.Mat">
                <label class="label is-size-7 is-uppercase has-text-grey-light">
                    {{ translate("admin_schedules_list.delete.mat_label") }}
                </label>
                <div class="control">
                    <div class="select is-fullwidth">
                        <select v-model.number="selectedMatId">
                            <option v-for="mat in store.matsForSelectedSchedule" :key="mat.id" :value="mat.id">
                                {{ mat.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <AffectedCategoriesPanel v-if="store.mode !== DeleteFightsMode.Category" />
        <CategoryDeleteList v-else />
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../../Common/translations";
    import { DeleteFightsMode, useDeletingFightsStore } from "./useDeletingFightsStore";
    import AffectedCategoriesPanel from "./AffectedCategoriesPanel.vue";
    import CategoryDeleteList from "./CategoryDeleteList.vue";

    const store = useDeletingFightsStore();

    const modeOptions = [
        { value: DeleteFightsMode.All, label: translate("admin_schedules_list.delete.scope_all") },
        { value: DeleteFightsMode.Schedule, label: translate("admin_schedules_list.delete.scope_by_schedule") },
        { value: DeleteFightsMode.Mat, label: translate("admin_schedules_list.delete.scope_by_mat") },
        { value: DeleteFightsMode.Category, label: translate("admin_schedules_list.delete.scope_by_category") },
    ];

    const selectedScheduleId = computed<number | null>({
        get: () => store.selectedSchedule?.id ?? null,
        set: id => {
            const schedule = store.schedules.find(candidate => candidate.id === id);
            if (schedule) {
                store.selectSchedule(schedule);
            }
        },
    });

    const selectedMatId = computed<number | null>({
        get: () => store.selectedMat?.id ?? null,
        set: id => {
            const mat = store.matsForSelectedSchedule.find(candidate => candidate.id === id);
            if (mat) {
                store.selectMat(mat);
            }
        },
    });
</script>
